import * as api from "../../../api";
import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { ALERT } from "../../../constants/actionTypes";

import "./ContactUs.css";
import { Link } from "react-router-dom";

const ContactUs = () => {
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const disable =
    name.trim() === "" ||
    subject.trim() === "" ||
    email.trim() === "" ||
    message.trim() === "" ||
    submitting ||
    !agreed;

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await api.contactUs({ name, email, message, subject });
      dispatch({
        type: ALERT,
        payload: {
          severity: "success",
          message: "Message sent",
          duration: 5000,
          display: true,
        },
      });
      setName("");
      setEmail("");
      setSubject("");
      setMessage("");
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contactUs__form container d-flex flex-column align-center my-40 w-100">
      <h2 className="font-subhead">Contact Our Team</h2>
      <p className="py-20">
        Fill your message below and we aill get back to you as soon as possible.
      </p>
      <form className="p-40 w-100">
        <div className="d-flex justify-between">
          <label className="d-flex flex-column w-45">
            <span className="py-10 px-5 font-heavy">Full Name</span>
            <input
              className="border-1 outline-0 p-20"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </label>
          <label className="d-flex flex-column w-45">
            <span className="py-10 px-5 font-heavy">Email Address</span>
            <input
              className="border-1 outline-0 p-20"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
        </div>
        <div className="my-20">
          <label className="d-flex flex-column">
            <span className="py-10 px-5 font-heavy">Subject</span>
            <input
              className="border-1 outline-0 p-20"
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </label>
        </div>
        <div className="my-20">
          <label className="d-flex flex-column">
            <span className="py-10 px-5 font-heavy">Message</span>
            <textarea
              className="border-1 outline-0 p-20"
              placeholder="..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </label>
        </div>
        <button
          style={{ opacity: disable ? "0.6" : "" }}
          className="d-flex justify-center align-center outline-0 border-0 font-big font-bold py-10 px-40 rounded"
          disabled={disable}
          onClick={handleSubmit}
        >
          SUBMIT
          {submitting && <div className="spin-white ml-10"></div>}
        </button>
        <div className="d-flex align-center mt-10 mx-10">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <span className="pl-10">
            I have read and agreed to the{" "}
            <Link to="/terms-and-condition">Privacy Policy</Link>
          </span>
        </div>
      </form>
    </div>
  );
};

export default ContactUs;
